// @flow

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './css/index.css';
import './css/squareplan-embedded.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import i18n from 'i18next';

// Set default i18n globally to ensure it's available
if (!window.i18n) {
  window.i18n = {
    t: (text) => text
  };
}

// Debug flag to help troubleshoot Redux store issues
console.log('[DEBUG] App initializing - Setting up Redux store and React components');

const container = document.getElementById('root');
const root = createRoot(container); // create a root.
root.render(<BrowserRouter>
  <App /></BrowserRouter>);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
